/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import isEmpty from 'lodash/isEmpty';

import { useAppStore } from "../../store/models/app";
import { useSubscriberStore } from "../../store/models/subscriber";
import { copyToClipboard } from "../../commons/utils/clipboard";
import { getIcsLinkKey } from "../../commons/utils/utils";

function removeWebcal ({ flags, userAgent, url }) {
    const edge = flags.edge;
    const chrome = flags.chrome;
    const browserVer = userAgent.browser.version;
    if ((edge && (browserVer * 1) < 16) ||
    (chrome && (browserVer.match(/^\d+/) && (browserVer.match(/^\d+/)[0] * 1) === 62) &&
    (browserVer.match(/\d+$/) && (browserVer.match(/\d+$/)[0] * 1) === 62))
    ) {
        console.log('removeWebCal() ');
        return url.replace('webcal:', ''); // remove protocol
    }
    return url;
}

function selectCalURL ({ appStore, urls }) {
    console.log('selectCalURL: appStore.selectedCalendar ', appStore.selectedCalendar );

    const urlKey = getIcsLinkKey(appStore.selectedCalendar);
    if (isEmpty(urls) || !urlKey) {
        return '';
    }
    
    console.log('selectCalURL: urlKey', urlKey);
    console.log('selectCalURL: urls: ', urls);
    
    let url = urls[urlKey];
    if (!url) {
        url = urls.webCalUrl;
    }

    if (!url) {
        return '';
    }

    url = removeWebcal({
        flags: appStore.flags,
        userAgent: appStore.userAgent, 
        url,
    });
    
    return url;
}

export default function useICSLink () {
    const appStore = useAppStore();
    const subscriberStore = useSubscriberStore();
    
    const [inProgress, setInProgress] = useState(false);
    const [calendarURL, setCalendarURL] = useState(selectCalURL({
        appStore, 
        urls: appStore.calendarURL,
    }));

    useEffect(() => {
        setInProgress(false);
        setCalendarURL(selectCalURL({
            appStore,
            urls: appStore.calendarURL,
        }));
    }, [appStore.observed.calendarURL]);
    

    function copyCalendarURL () {
        console.log('calendarURL(): ', calendarURL);
        copyToClipboard(calendarURL);
    }

    function subuscriberStatus () {
        setInProgress(true);
        subscriberStore.subscriberStatusPoll();
    }

    return {
        calendarURL,
        copyCalendarURL,
        subuscriberStatus,
        inProgress,
        selectedCalendar: appStore.selectedCalendar,
    };
}
